<template>
  <div
    class="relative w-full mx-auto px-4 md:px-8 gap-6 md:gap-8 flex flex-col items-center text-center"
  >
    <h1
      class="text-3xl md:text-5xl font-bold text-gray-900 text-center"
      :style="{ 'line-height': 'normal' }"
    >
      <span class="inline-flex items-center justify-center gap-2 flex-wrap">
        <!-- <img
          src="/icons/uk-flag.png"
          :alt="$t('landing.about.english')"
          class="size-6 md:size-8 scale-x-[-1] align-middle"
        /> -->
        <span>{{ $t('landing.welcome.headline') }}</span>
        <span class="px-2 bg-yellow-400/30 rounded-md">{{
          $t('landing.welcome.headlineHighlight')
        }}</span>
        <!-- <img
          src="/icons/uk-flag.png"
          :alt="$t('landing.about.english')"
          class="size-6 md:size-8 align-middle"
        /> -->
      </span>
    </h1>

    <p class="text-base md:text-xl text-gray-600 max-w-2xl">
      {{ $t('landing.welcome.subtitleShort') }}
    </p>

    <div class="w-full gap-4 flex flex-col">
      <BaseButton
        class="max-w-[250px] mx-auto"
        color="primary-gradient"
        :to="{ name: 'signin' }"
      >
        <span>{{ $t('landing.welcome.startLearning') }}</span>
      </BaseButton>
    </div>

    <BaseHappy />
  </div>
</template>

<script>
import BaseButton from '@/components/Base/BaseButton.vue'
import BaseHappy from '@/components/Base/BaseHappy.vue'

export default {
  name: 'LandingWelcome',

  components: { BaseButton, BaseHappy }
}
</script>

<style scoped>
.english {
  /* background-image: url('https://upload.wikimedia.org/wikipedia/en/a/ae/Flag_of_the_United_Kingdom.svg'); */
  /* background-size: cover; */
  /* background: linear-gradient(
    45deg,
    #012169 0%,
    #012169 33%,
    #ffffff 33%,
    #ffffff 66%,
    #c8102e 66%,
    #c8102e 100%
  ); */
  /* background: linear-gradient(45deg, #012169 0%, #ffffff 50%, #c8102e 100%); */

  /* background-position: top;
  background-size: cover;
  background-clip: text;
  -webkit-background-clip: text;
  -webkit-text-fill-color: transparent; */

  /* Stroke */
  /* -webkit-text-stroke: 2px white; */
}
</style>
